export default __webpack_public_path__ + "static/media/witness.a6e44779.svg";